import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  lastText: string;

  transform(array: any[], text: string | undefined, field: string | undefined, filterIncludes?: boolean) {

    if (text === '' || text === undefined || text === null || field === undefined) {
      return array;
    }

    const textTransform = text.toLowerCase().trim();
    let arrayFiltered = filterIncludes 
    ? array.filter((item: any) => item[field].toLowerCase().includes( textTransform ))
    : array.filter((item: any) => item[field].toLowerCase().startsWith( textTransform ))

    if (arrayFiltered.length > 0) {
      this.lastText = textTransform;
    } else {
      if (this.lastText === undefined) {
        return array;
      }
      arrayFiltered = filterIncludes 
      ? array.filter((item: any) => item[field].toLowerCase().includes( this.lastText ))
      : array.filter((item: any) => item[field].toLowerCase().startsWith( this.lastText ))
    }

    return arrayFiltered;
  }

}